import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Input } from "../../../../../_metronic/_partials/controls";
import { BlockOrg } from "../../../../RoleChecker";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { getPeriodeKurbanAll } from "../../../Donation/_redux/periode-kurban/periodeKurbanCrud";

export function AreaEditForm({
  saveArea,
  actionsLoading,
  area,
  roleMaster,
  onHide,
  id,
}) {
  // Validation schema
  const shape = {
    name: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Nama Area Wajib Diisi"),
  };

  const AreaEditSchema = Yup.object().shape(shape);

  const [options, setOptions] = useState({
    thk_period: [],
  });

  const [initialValue, setInitialValue] = useState({
    name: "",
    thk_period_uuid: "",
  });
  const [currentPeriod, setCurrentPeriod] = useState("");

  useEffect(() => {
    getPeriodeKurbanAll().then((res) => {
      const { data } = res.data;
      setOptions((prev) => ({
        ...prev,
        thk_period: data,
      }));
      const activePeriod = data.find(({ is_active }) => is_active == true);
      setCurrentPeriod(activePeriod);
    });
  }, [area]);

  useEffect(() => {
    if (!id) {
      setInitialValue((prev) => ({
        ...prev,
        thk_period_uuid: currentPeriod.uuid,
      }));
    } else {
      console.log("dalem", area);
      setInitialValue(area);
    }
  }, [currentPeriod]);

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValue}
        validationSchema={AreaEditSchema}
        onSubmit={(values) => {
          saveArea(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <>
            <Modal.Body className="overlay overlay-block cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  <div className="col">
                    <Field
                      name="name"
                      component={Input}
                      placeholder="Nama Wilayah..."
                      label="Nama Wilayah"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col">
                    <label>Pilih Periode</label>
                    <Autocomplete
                      name="thk_period_uuid"
                      options={options.thk_period}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, value) => {
                        if (value) {
                          setFieldValue("thk_period_uuid", value.uuid);
                        } else {
                          setFieldValue("thk_period_uuid", "");
                        }
                      }}
                      value={
                        options.thk_period.length > 0 &&
                        options.thk_period.find(
                          (item) => item.uuid === values.thk_period_uuid
                        )
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Pilih Periode"
                          variant="outlined"
                          disableClearable
                          size="small"
                        />
                      )}
                    />
                    <label>
                      Harap Pilih <b>Periode</b>
                    </label>
                    <ErrorMessage
                      name="bank"
                      render={(msg) => (
                        <div style={{ color: "red" }}>{msg}</div>
                      )}
                    />
                  </div>
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              {BlockOrg() && (
                <button
                  type="submit"
                  onClick={() => handleSubmit()}
                  className="btn btn-primary btn-elevate"
                >
                  Save
                </button>
              )}
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}
